import { createSelector } from 'reselect';
import { selectHrModuleState } from './index';

export const selectSettingPageState = createSelector(
    selectHrModuleState,
    state => state.settingPageState,
);

